import { useState, useEffect } from "react";
import { Spin } from "antd";

import API from "scripts/api";
import Resources from "scripts/resources";

import Rocketman from "images/rocketman.png";
import GoldKey from "images/goldenkey.png";

const Component = () => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { loaded, text } = state;

	const componentDidMount = () => {
		API.about()
			.then(({ data }) => {
				setState((prevState) => ({
					...prevState,
					...data,
					loaded: true,
				}));
			})
			.catch();

		document.title = Resources.aboutUs;
	};

	useEffect(componentDidMount, []);

	return loaded ? (
		<div className="page-about">
			<div className="container">
				<img
					src={Rocketman}
					alt={`${Resources.about} ${Resources.bakelid}`}
					className="image"
				/>
				<h1 className="heading">
					<img
						src={GoldKey}
						alt={Resources.goldenKey}
					/>
					{`${Resources.about} ${Resources.bakelid}`}
				</h1>
				<div
					className="info"
					dangerouslySetInnerHTML={{ __html: text }}
				/>
			</div>
		</div>
	) : (
		<Spin className="page-loading" />
	);
};

export default Component;
